export default {
    colors: {
        primary: "#5636D3",

        secondary: "#FF872C",
        secondary_light: "#ff872c2b",

        success: "#12A454",
        success_light: "#12a4542b",

        attention: "#E83F5B",
        attention_light: "#e83f5b2b",

        shape: "#FFFFFF",
        shape_transparent: "#ffffff61",

        title: "#363F5F",
        text: "#969CB2",
        text_dark: "#000000",
        backgroud: "#F0F2F5",

        body_transparent: "#0048ff1c",
    },

    fonts: {
        bold: "bold",
        light: "light",
        medium: "medium",
        regular: "regular",
    },
}
